import { render, staticRenderFns } from "./HospitalAdminEdit.vue?vue&type=template&id=29b27f6c"
import script from "./HospitalAdminEdit.vue?vue&type=script&lang=js"
export * from "./HospitalAdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports